const size = {
  mobile: "960px",
  mobilePhone: "460px",
}

export const devices = {
  mobile: `(max-width: ${size.mobile})`,
  mobilePhone: `(max-width: ${size.mobilePhone})`,
}
